import React, { PropTypes, Component } from 'react'
import { Metrics, Fonts, Colors } from '../../Themes'
import { fromJS } from 'immutable'
import styled from 'styled-components'
import List from '../List'
import ListItem from '../ListItem'
import Arrow from '../../svg-icons/Arrow'

const DropdownContainer = styled.div``

const Container = styled.div`
  position: relative;
  background: white;
  border: ${Metrics.borders.default};
  cursor: pointer;
  border-radius: ${Metrics.borders.defaultRadius};
  min-height: ${Metrics.components.inputFormHeight};
  padding: calc(${Metrics.margins.small} - 1px);
  .dropdown-header {
    ${Fonts.style.Input};
    color: ${Colors.black};
    position: relative;
    .placeholder {
      ${Fonts.style.Input};
      color: ${Colors.darkGrey};
    }
    .arrow {
      position: absolute;
      right: 10px;
      right: 0;
      top: -${Metrics.margins.tiny};
      transform: rotate(180deg);
      fill: ${Colors.primary};
      &.open {
        transform: rotate(0deg);
      }
    }
  }

  .dropdown-list {
    display: ${props => (props.open ? 'block' : 'none')};
    position: absolute;
    left: -1px;
    z-index: 2;
    width: calc(100% + 2px);
    background: white;
    border: ${Metrics.borders.headerBorder};
    border-top: none;
    border-radius: ${Metrics.borders.defaultRadius};
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    ${Fonts.style.Input};
    color: ${Colors.black};
  }
`

const Error = styled.div`
  ${Fonts.style.Input};
  color: ${Colors.red};
  margin-top: ${Metrics.margins.tiny};
`

class Dropdown extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
    this.handleClick = this.handleClick.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { options, selectedOption, error } = this.props
    const { open } = this.state
    if (
      !fromJS(options).equals(fromJS(nextProps.options)) ||
      selectedOption !== nextProps.selectedOption ||
      error !== nextProps.error ||
      open !== nextState.open
    ) {
      return true
    }
    return false
  }

  handleClick () {
    this.setState({ open: !this.state.open })
  }

  handleBlur () {
    setTimeout(() => {
      if (this.props.handleBlur) {
        this.props.handleBlur()
      }
      this.setState({
        open: false,
        value: ''
      })
    }, 250)
  }

  render () {
    const {
      placeholder,
      handleSelect,
      selectedOption,
      options,
      accessor,
      name,
      required,
      error,
      className
    } = this.props

    const list =
      options.length > 0 ? (
        options.map((el, index) => {
          return (
            <ListItem
              key={index}
              value={el}
              onClick={() => {
                handleSelect(el)
                this.handleBlur()
              }}>
              {accessor ? accessor(options[index]) : `${options[index]}`}
            </ListItem>
          )
        })
      ) : (
        <span>There are no elements</span>
      )

    const header = (selectedOption !== null &&
      (accessor ? accessor(selectedOption) : selectedOption)) || (
      <span className='placeholder'>{placeholder}</span>
    )

    return (
      <DropdownContainer required={required} id={name}>
        <Container
          onBlur={this.handleBlur}
          onClick={this.handleClick}
          open={this.state.open}
          tabIndex={'-1'}
          className={`${className} dropdown-component`}>
          <div className='dropdown-header'>
            {header}
            <Arrow className={`arrow ${this.state.open && 'open'}`} />
          </div>
          <div className='dropdown-list'>
            <List className={'list'} hide={!this.state.open}>
              {list}
            </List>
          </div>
        </Container>
        {error && <Error>{error}</Error>}
      </DropdownContainer>
    )
  }
}

Dropdown.propTypes = {
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.any,
  placeholder: PropTypes.string.isRequired,
  handleSelect: PropTypes.func,
  accessor: PropTypes.func,
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  name: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js